import Stats from './Stats';
import './Stats.scss';

export default Stats;
